var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Location } from '@angular/common';
import { BpgCommonService } from '../app/bpg-common/services/bpg-common.service';
import { EnvironmentConfiguration } from './environment/services/environment.configuration';
import { DataService } from './bpg-common/services/data.services';
var AppComponent = /** @class */ (function () {
    function AppComponent(router, location, data, bpgCommonService, environment1) {
        var _this = this;
        this.router = router;
        this.location = location;
        this.data = data;
        this.bpgCommonService = bpgCommonService;
        this.environment1 = environment1;
        this.path = '';
        this.isActive = false;
        this.backgroundActive = false;
        this.transitionBannerData = {
            message: 'Notice: BPG Connect is transitioning to ERG Connect as part of Evolving Together: BPG To ERG. You may see some changes during this process. Please pardon the "dust"—completion is expected by June 1st. Thanks for your patience!',
            type: 'warning',
            dismissalKey: 'transition-banner-dismissed'
        };
        this.title = 'bpg-webapp';
        this.expiryMsg = "Your session will expire in 5 minutes. Kindly save all your changes";
        router.events.subscribe(function (event) { return __awaiter(_this, void 0, void 0, function () {
            var queryParams, codeResponse, authError, codeVerifier;
            return __generator(this, function (_a) {
                if (event instanceof NavigationStart) {
                    queryParams = new URLSearchParams(window.location.search);
                    codeResponse = queryParams.get('code');
                    authError = queryParams.get('error');
                    if (codeResponse && !authError) {
                        codeVerifier = sessionStorage.getItem('code_verifier');
                        sessionStorage.clear();
                        if (codeVerifier) {
                            sessionStorage.setItem('code_verifier', codeVerifier);
                        }
                        sessionStorage.setItem('codeResponse', codeResponse);
                    }
                }
                return [2 /*return*/];
            });
        }); });
        this.router.events.subscribe(function (_val) {
            _this.path = _this.location.path();
        });
    }
    AppComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Redirect bpg hostnames to erg hostnames for QA/PROD before app bootstraps auth-sensitive flows.
        var hostname = window.location.hostname;
        var redirectHost = this.environment1.envName === 'qa' && hostname === 'qa.bpg.toyota.com'
            ? 'qa.erg.toyota.com'
            : this.environment1.envName === 'prod' && hostname === 'bpg.toyota.com'
                ? 'erg.toyota.com'
                : null;
        if (redirectHost && !window.location.search.includes('code=')) {
            var url = new URL(window.location.href);
            url.hostname = redirectHost;
            window.location.href = url.toString();
            return;
        }
        window.setTimeout(function () {
            $('#tokenExpiry').modal('show');
        }, (600000 * 5));
        if (sessionStorage.getItem('id_token') != null && sessionStorage.getItem('XAapiKey') != null) {
            this.isActive = true;
        }
        if (this.isActive === false) {
            this.bpgCommonService.isTokenPresent.subscribe(function (tokenRes) {
                if (tokenRes) {
                    _this.isActive = tokenRes;
                }
            });
        }
        window.setTimeout(function () {
            _this.refreshToken();
        }, (600000 * 5));
        if (this.environment1.envName === 'default' || this.environment1.envName === 'local' || this.environment1.envName === 'staging') {
            localStorage.setItem('userManagementUrl', this.environment1.apiBaseUrl + '7000');
            localStorage.setItem('eventManagementUrl', this.environment1.apiBaseUrl + '7001');
            localStorage.setItem('financialManagementUrl', this.environment1.apiBaseUrl + '7002');
        }
        else if (this.environment1.envName === 'qa' || this.environment1.envName === 'prod') {
            localStorage.setItem('userManagementUrl', this.environment1.apiBaseUrl);
            localStorage.setItem('eventManagementUrl', this.environment1.eventapiBaseUrl);
            localStorage.setItem('financialManagementUrl', this.environment1.financeapiBaseUrl);
        }
        else {
            localStorage.setItem('userManagementUrl', this.environment1.apiBaseUrl);
            localStorage.setItem('eventManagementUrl', this.environment1.apiBaseUrl);
            localStorage.setItem('financialManagementUrl', this.environment1.apiBaseUrl);
        }
        this.data.siteEffectedPopup.subscribe(function (data) {
            if (data === 'true') {
                _this.backgroundActive = true;
            }
            else {
                _this.backgroundActive = false;
            }
        });
    };
    AppComponent.prototype.refreshToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.bpgCommonService.refreshToken();
                return [2 /*return*/];
            });
        });
    };
    AppComponent.prototype.clearTime = function () {
        $('#tokenExpiry').modal('hide');
        window.location.reload();
    };
    return AppComponent;
}());
export { AppComponent };
